import { combineReducers } from 'redux';

import { reducer as issuejwt } from './issuejwtModule';
import twoFactor from './twoFactor/twoFactorReducer';

export default combineReducers({
	issuejwt,
	twoFactor,
});
